import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {GetUserExperienceApiData, GetUserExperienceApiDataFormatted, PostPutUserExperienceApiData, PostPutUserExperienceReqObj} from './user-experience-http-interfaces';
import {GeneralHttpHelperService} from '../../helpers/general-http-helper.service';

const USER_EXPERIENCE_API_ROUTES = {
  GET_USER_EXPERIENCES: 'landing/admin/user-experience',
  POST_USER_EXPERIENCE: 'landing/admin/user-experience',
  PUT_USER_EXPERIENCE: 'landing/admin/user-experience/:experienceId',
  DELETE_USER_EXPERIENCE: 'landing/admin/user-experience/:experienceId',
  GET_LANDING_USER_EXPERIENCE: 'landing/web/user-experience/random',
};
@Injectable({
  providedIn: 'root'
})
export class UserExperienceHttpService {


  constructor(private httpClient: HttpClient,
              private generalHttpHelperService: GeneralHttpHelperService) { }
  private getUserExperiencesReq(urlParams?: Record<string, any>): Observable<GetUserExperienceApiData> {
    const apiUrl = urlParams
      ? this.generalHttpHelperService.addUrlParams(USER_EXPERIENCE_API_ROUTES.GET_USER_EXPERIENCES, urlParams)
      : USER_EXPERIENCE_API_ROUTES.GET_USER_EXPERIENCES;
    return this.httpClient.get(apiUrl) as any;
  }

  getUserExperiences(urlParams?: Record<string, any>): Promise<GetUserExperienceApiDataFormatted> {
    return new Promise<GetUserExperienceApiDataFormatted>((resolve, reject) => {
      this.getUserExperiencesReq(urlParams).subscribe((res: GetUserExperienceApiData) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private getLandingUserExperiencesReq(): Observable<GetUserExperienceApiData> {
    return this.httpClient.get(USER_EXPERIENCE_API_ROUTES.GET_LANDING_USER_EXPERIENCE) as any;
  }

  getLandingUserExperiences(): Promise<GetUserExperienceApiDataFormatted> {
    return new Promise<GetUserExperienceApiDataFormatted>((resolve, reject) => {
      this.getLandingUserExperiencesReq().subscribe((res: GetUserExperienceApiData) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private postUserExperienceReq(bodyParams: any): Observable<PostPutUserExperienceApiData> {
    return this.httpClient.post(USER_EXPERIENCE_API_ROUTES.POST_USER_EXPERIENCE, bodyParams) as any;
  }

  postUserExperience(bodyParams: any): Promise<PostPutUserExperienceApiData> {
    return new Promise<any>((resolve, reject) => {
      this.postUserExperienceReq(bodyParams).subscribe((res: PostPutUserExperienceApiData) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private putUserExperienceReq(urlParam: Record<string, any>, bodyParams: any): Observable<PostPutUserExperienceApiData> {
    const apiUrl = this.generalHttpHelperService.replaceUrlParamsWithValues(USER_EXPERIENCE_API_ROUTES.PUT_USER_EXPERIENCE, urlParam);
    return this.httpClient.post(apiUrl, bodyParams) as any;
  }

  putUserExperience(urlParam: Record<string, any>, bodyParams: any): Promise<PostPutUserExperienceApiData> {
    return new Promise<any>((resolve, reject) => {
      this.putUserExperienceReq(urlParam, bodyParams).subscribe((res: PostPutUserExperienceApiData) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private deleteUserExperienceReq(urlParam: Record<string, any>): Observable<PostPutUserExperienceApiData> {
    const url = this.generalHttpHelperService.replaceUrlParamsWithValues(USER_EXPERIENCE_API_ROUTES.DELETE_USER_EXPERIENCE, urlParam);
    return this.httpClient.delete(url) as any;
  }

  deleteUserExperience(urlParam: Record<string, any>): Promise<PostPutUserExperienceApiData> {
    return new Promise<any>((resolve, reject) => {
      this.deleteUserExperienceReq(urlParam).subscribe((res: PostPutUserExperienceApiData) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }
}
